module.exports = __webpack_public_path__ + "static/media/EyeOn.a9ddee69.svg";